module.exports = __webpack_public_path__ + "static/img/banner_solutions_intelligent.446e4ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_intelligent.png
// module id = vS1d
// module chunks = 10